import { Component, input } from '@angular/core';

@Component({
  selector: 'app-single-bloc-skeleton',
  templateUrl: './single-bloc-skeleton.component.html',
  styleUrls: ['./single-bloc-skeleton.component.scss'],
  host: {
    '[style.width]': 'width()',
    '[style.height]': 'height()',
    '[style.border-radius]': 'borderRadius()',
    '[style.margin-top]': 'margin()',
    '[style.margin-bottom]': 'margin()',
  },
})
export class SingleBlocSkeletonComponent {
  readonly width = input<string>('100%');
  readonly height = input<string>('1em');
  readonly borderRadius = input<string>('6px');
  readonly margin = input<string>('6px');
}
